import { Tournament, TournamentInvitation, TournamentInvitationWithDetails } from '../../domain/models';
import { TournamentInvitationRepository } from '../../domain/repositories/TournamentInvitationRepository';
import { TournamentInvitationDataSource } from '../datasources/TournamentInvitationDataSource';
import { invitationEntityToModel, invitationWithDetailsEntityToModel, tournamentEntityToModel } from '../entities';

export class TournamentInvitationRepositoryImpl implements TournamentInvitationRepository {
  constructor(private dataSource: TournamentInvitationDataSource) {}

  async send(
    tournamentId: string,
    inviterId: string,
    inviteeId: string,
    message?: string
  ): Promise<TournamentInvitation> {
    const entity = await this.dataSource.create(tournamentId, inviterId, inviteeId, message);
    return invitationEntityToModel(entity);
  }

  async accept(invitationId: string): Promise<TournamentInvitation> {
    const entity = await this.dataSource.update(invitationId, 'accepted');
    return invitationEntityToModel(entity);
  }

  async decline(invitationId: string): Promise<TournamentInvitation> {
    const entity = await this.dataSource.update(invitationId, 'declined');
    return invitationEntityToModel(entity);
  }

  async cancel(invitationId: string): Promise<TournamentInvitation> {
    const entity = await this.dataSource.update(invitationId, 'cancelled');
    return invitationEntityToModel(entity);
  }

  async getReceived(
    userId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<TournamentInvitationWithDetails[]> {
    const entities = await this.dataSource.getReceived(userId, limit, offset);
    return entities.map((e) => invitationWithDetailsEntityToModel(e, 'received'));
  }

  async getSent(
    userId: string,
    limit: number = 20,
    offset: number = 0
  ): Promise<TournamentInvitationWithDetails[]> {
    const entities = await this.dataSource.getSent(userId, limit, offset);
    return entities.map((e) => invitationWithDetailsEntityToModel(e, 'sent'));
  }

  async getByTournamentAndUser(
    tournamentId: string,
    inviteeId: string
  ): Promise<TournamentInvitation | null> {
    const entity = await this.dataSource.getByTournamentAndUser(tournamentId, inviteeId);
    return entity ? invitationEntityToModel(entity) : null;
  }

  async joinByCode(code: string, userName: string): Promise<Tournament> {
    const entity = await this.dataSource.joinTournamentByCode(code, userName);
    return tournamentEntityToModel(entity);
  }
}
